import { StoreService } from "@3gaam/api/services";
import { InvoicesOutput, WalletBalanceOutput, InvoiceCorePortable } from "@3gaam/api/types/store";
import { InvoicesInput } from "@3gaam/api/types/storeMapped";
import { paginationThunk } from "@3gaam/shared/hooks/useQuery";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const invoicesAction = createAsyncThunk(
  "@3gaam/app/src/store/invoices",
  async (payload: InvoicesInput, thunkAPI) => {
    const res = await paginationThunk<InvoicesInput, InvoiceCorePortable, InvoicesOutput>(StoreService.invoices, payload);
    
    return res.data;
  },
);

export const walletBalanceAction = createAsyncThunk(
  "@3gaam/app/src/store/walletBalance",
  async (payload: string, thunkAPI) => {
    const res = await StoreService.walletBalance(payload);
    return res.data;
  },
);

interface WithLoadingState<T> {
  success: boolean;
  requesting: boolean;
  error: boolean;
  data?: T;
}

export interface StoreState {
  invoices?: WithLoadingState<InvoicesOutput>;
  walletBalance?: WithLoadingState<WalletBalanceOutput>;
}

const initialState: StoreState = {
  invoices: { success: false, error: false, requesting: false },
  walletBalance: { success: false, error: false, requesting: false },
};

export const storeSlice = createSlice({
  name: "@3gaam/app/src/store",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(invoicesAction.pending, (state, action) => {
        state.invoices = {
          ...state.invoices,
          success: false,
          requesting: true,
          error: false,
        };
      })
      .addCase(invoicesAction.fulfilled, (state, action) => {
        state.invoices = {
          success: true,
          requesting: false,
          error: false,
          data: action.payload,
        };
      })
      .addCase(invoicesAction.rejected, (state, action) => {
        state.invoices = {
          ...state.invoices,
          success: false,
          requesting: false,
          error: true,
        };
      })
      .addCase(walletBalanceAction.pending, (state, action) => {
        state.walletBalance = {
          ...state.walletBalance,
          success: false,
          requesting: true,
          error: false,
        };
      })
      .addCase(walletBalanceAction.fulfilled, (state, action) => {
        state.walletBalance = {
          success: true,
          requesting: false,
          error: false,
          data: action.payload,
        };
      })
      .addCase(walletBalanceAction.rejected, (state, action) => {
        state.walletBalance = {
          ...state.walletBalance,
          success: false,
          requesting: false,
          error: true,
        };
      });
  },
});

export default storeSlice.reducer;
